import { render } from "./EmailVerifiedHospital.vue?vue&type=template&id=5ce560e0&ts=true"
import script from "./EmailVerifiedHospital.vue?vue&type=script&lang=ts"
export * from "./EmailVerifiedHospital.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__